(function () {
  'use strict';

  const ROOTS = document.querySelectorAll('[data-lap-root]');
  if (!ROOTS.length) return;

  const DIRECTIONS = [
    {
      id: 'energy', name: 'Energie & mitocondrii', symptom: 'energie scăzută, epuizare, cădere după-amiaza', color: '#e28b25',
      main: 'nmn', complements: ['tmg', 'coq10'], terms: ['metabolism energetic', 'NAD+', 'mitocondrii'],
      summary: 'Energia de peste zi poate avea multe cauze. După somn, alimentație și mișcare, această direcție grupează produsele folosite pentru susținerea metabolismului energetic celular.',
      chain: ['Clarifici întâi somnul, alimentația și nivelul de activitate', 'Alegi un singur produs principal pentru metabolismul energetic', 'Adaugi doar o completare care răspunde contextului tău']
    },
    {
      id: 'cell', name: 'Îmbătrânire sănătoasă', symptom: 'NAD+, protecție celulară, menținere pe termen lung', color: '#179b69',
      main: 'nmn', complements: ['resveratrol', 'tmg'], terms: ['NAD+', 'stres oxidativ', 'metilare'],
      summary: 'Îmbătrânirea sănătoasă nu depinde de o singură moleculă. Aici începem simplu, cu o opțiune centrală și două completări care rămân opționale.',
      chain: ['Alegi o prioritate ușor de urmat', 'Eviți suprapunerea mai multor produse cu același rol', 'Evaluezi consecvența înainte să extinzi protocolul']
    },
    {
      id: 'brain', name: 'Focus & claritate', symptom: 'ceață mentală, memorie, concentrare', color: '#5068dc',
      main: 'citicoline', complements: ['magtein', 'omega3'], terms: ['acetilcolină', 'magneziu', 'membrane neuronale'],
      summary: 'Focusul este influențat de somn, stres, alimentație și starea generală. Produsele de aici sunt organizate după rol, fără a presupune cauza simptomelor.',
      chain: ['Începi cu produsul cel mai apropiat de obiectivul de focus', 'Adaugi o singură completare pentru structură sau aport mineral', 'Oprești și ceri sfat medical dacă simptomele persistă']
    },
    {
      id: 'stress', name: 'Stres & somn', symptom: 'agitație, adormire dificilă, somn superficial', color: '#7757cc',
      main: 'magnesium', complements: ['glycine', 'ashwagandha'], terms: ['relaxare', 'rutină de seară', 'adaptogeni'],
      summary: 'Rutina de somn și gestionarea stresului rămân fundația. Suplimentele pot fi doar un sprijin, iar produsul principal ales aici este opțiunea mai simplă de început.',
      chain: ['Corectezi mai întâi programul, lumina și cofeina', 'Începi cu o opțiune simplă, bine tolerată', 'Păstrezi adaptogenii ca alegere separată, mai ales dacă iei medicamente']
    },
    {
      id: 'heart', name: 'Inimă & metabolism', symptom: 'trigliceride, glicemie, tensiune, circulație', color: '#d94c54',
      main: 'omega3', complements: ['coq10', 'tmg'], terms: ['EPA/DHA', 'CoQ10', 'homocisteină'],
      summary: 'Markerii cardiovasculari și metabolici trebuie interpretați împreună cu medicul. Arhitectul organizează produsele după rol și nu înlocuiește analizele sau tratamentul.',
      chain: ['Pornești de la analize și recomandarea medicului', 'Alegi un singur produs cu rol clar', 'Verifici interacțiunile înainte de orice combinație']
    },
    {
      id: 'skin', name: 'Piele & articulații', symptom: 'elasticitate, hidratare, colagen, mobilitate', color: '#d4628f',
      main: 'collagen', complements: ['hyaluronic', 'vitaminC'], terms: ['colagen', 'hidratare', 'vitamina C'],
      summary: 'Pielea și articulațiile împart componente structurale comune. Începem cu materia primă, apoi păstrăm hidratarea și vitamina C drept completări.',
      chain: ['Alegi materia primă ca produs principal', 'Adaugi hidratarea sau vitamina C doar dacă se potrivesc obiectivului', 'Urmărești consecvența pe termen suficient']
    },
    {
      id: 'immune', name: 'Imunitate & apărare', symptom: 'sezon rece, recuperare, aport de micronutrienți', color: '#269eb6',
      main: 'vitaminC', complements: ['zinc', 'd3k2'], terms: ['vitamina C', 'zinc', 'vitamina D'],
      summary: 'Funcția imunitară depinde de somn, alimentație, vaccinare și starea generală. Suplimentele nu tratează infecțiile; această direcție ajută doar la compararea opțiunilor uzuale.',
      chain: ['Verifici alimentația și eventualele deficite', 'Alegi un singur micronutrient de început', 'Pentru vitamina D folosești analize și recomandare profesionistă']
    },
    {
      id: 'muscle', name: 'Mușchi & vitalitate', symptom: 'forță, masă musculară, recuperare, performanță', color: '#4a8b38',
      main: 'creatine', complements: ['eaa', 'protein'], terms: ['creatină', 'aminoacizi', 'proteină'],
      summary: 'Antrenamentul și aportul adecvat de proteine sunt fundația. Recomandarea principală este simplă, iar completările depind de câtă proteină obții deja din alimentație.',
      chain: ['Stabilești un ritm de antrenament și aportul proteic', 'Alegi produsul principal pentru consecvență', 'Adaugi aminoacizi sau proteină numai dacă alimentația nu acoperă necesarul']
    }
  ];

  const PRODUCTS = {
    nmn: {
      name: 'NMN', role: 'Produs principal · metabolism energetic', days: 60, fallbackPrice: 499,
      reason: 'O opțiune centrală pentru utilizatorii care caută un precursor NAD+, prezentată fără promisiunea unui efect garantat.',
      warning: 'Datele despre interacțiunile NMN cu medicamentele sunt încă limitate. Confirmă cu medicul înainte de utilizare.',
      ageBoost: true,
      options: [
        { handle: 'nmn-60-capsule-x-500mg', variant: '500 mg', label: 'Capsule 500 mg · 60 capsule', days: 60, fallbackPrice: 499 },
        { handle: 'nmn-60-capsule-x-500mg', variant: '300 mg', label: 'Capsule 300 mg · 60 capsule', days: 60, fallbackPrice: 379 },
        { handle: 'nmn-pulbere-30-de-porții', variant: '15g', label: 'Pulbere 15 g · 30 doze', days: 30, fallbackPrice: 219 },
        { handle: 'nmn-pulbere-30-de-porții', variant: '30g', label: 'Pulbere 30 g · 60 doze', days: 60, fallbackPrice: 399 }
      ]
    },
    coq10: {
      name: 'Coenzima Q10', role: 'Completare · metabolism energetic', days: 30, fallbackPrice: 219, ageBoost: true,
      reason: 'O completare de luat în calcul mai ales după 45 de ani sau când vrei să discuți cu medicul despre contextul tratamentului cu statine.',
      warning: 'Poate interacționa cu warfarina și insulina și poate fi incompatibilă cu unele tratamente oncologice.',
      options: [{ handle: 'coenzima-q10-moleqlar', label: '200 mg · 60 capsule', days: 30, fallbackPrice: 219 }]
    },
    tmg: {
      name: 'TMG (betaină)', role: 'Completare · metilare', days: 30, fallbackPrice: 149,
      reason: 'O completare simplă pentru utilizatorii care aleg NMN și vor să înțeleagă rolul metilării.',
      options: [{ handle: 'tmg-betaina', label: 'Capsule · 60 bucăți', days: 30, fallbackPrice: 149 }]
    },
    resveratrol: {
      name: 'Trans-Resveratrol', role: 'Completare · polifenol', days: 60, fallbackPrice: 299,
      reason: 'O completare opțională, disponibilă în capsulă sau pulbere, pentru direcția de îmbătrânire sănătoasă.',
      warning: 'Poate influența agregarea plachetară. Discută utilizarea cu medicul dacă iei anticoagulante sau antiagregante.',
      options: [
        { handle: 'resveratrol-veri-te-capsule-30g-60-capsule', label: 'Capsule · 60 bucăți', days: 60, fallbackPrice: 299 },
        { handle: 'resveratrol-pulbere-60-doze-30gr', label: 'Pulbere 30 g · 60 porții', days: 60, fallbackPrice: 259 }
      ]
    },
    citicoline: {
      name: 'Citicolină (CDP-Colină)', role: 'Produs principal · colină', days: 30, fallbackPrice: 169,
      reason: 'Un punct de pornire clar pentru cei interesați de aportul de colină și focus, fără a presupune cauza ceții mentale.',
      warning: 'Dacă urmezi tratament neurologic sau psihiatric, verifică folosirea cu medicul sau farmacistul.',
      options: [{ handle: 'citicolina-cdp-colina-moleqlar', label: '500 mg · 60 capsule', days: 30, fallbackPrice: 169 }]
    },
    magtein: {
      name: 'Magneziu L-Treonat', role: 'Completare · aport de magneziu', days: 45, fallbackPrice: 339, ageBoost: true,
      reason: 'O formă de magneziu aleasă frecvent pentru direcția cognitivă; dovezile clinice sunt încă în dezvoltare.',
      warning: 'Magneziul poate reduce absorbția unor antibiotice și bisfosfonați; momentul administrării trebuie verificat.',
      options: [{ handle: 'magneziu-l-treonat', label: '90 capsule', days: 45, fallbackPrice: 339 }]
    },
    omega3: {
      name: 'Omega-3 Qmega', role: 'EPA și DHA', days: 30, fallbackPrice: 239, ageBoost: true,
      reason: 'O opțiune comună direcțiilor inimă și creier, utilă mai ales când aportul de pește este redus.',
      warning: 'Dozele mari pot influența coagularea. Dacă iei anticoagulante, medicul poate recomanda monitorizare.',
      options: [{ handle: 'omega-3-qmega', label: '90 capsule', days: 30, fallbackPrice: 239 }]
    },
    magnesium: {
      name: 'Magneziu Bisglicinat', role: 'Produs principal · aport de magneziu', days: 60, fallbackPrice: 159,
      reason: 'O variantă simplă de început pentru aportul de magneziu, înaintea combinațiilor mai complexe pentru somn.',
      warning: 'Poate reduce absorbția unor antibiotice și bisfosfonați; verifică distanța dintre administrări.',
      options: [{ handle: 'magneziu-bisglicinat-moleqlar', label: '225 mg · 120 capsule', days: 60, fallbackPrice: 159 }]
    },
    glycine: {
      name: 'Glicină', role: 'Completare · aminoacid', days: 60, fallbackPrice: 149,
      reason: 'O completare simplă pentru rutina de seară, care poate fi evaluată separat de alte produse.',
      options: [{ handle: 'glicina-pulbere-moleqlar-300g', label: 'Pulbere 300 g', days: 60, fallbackPrice: 149 }]
    },
    ashwagandha: {
      name: 'Ashwagandha', role: 'Completare · adaptogen', days: 60, fallbackPrice: 279,
      reason: 'Păstrată ca opțiune, nu ca fundație implicită, deoarece necesită mai multă atenție la context și medicație.',
      warning: 'Poate interacționa cu medicamente pentru diabet, tensiune, tiroidă, sedative, anticonvulsivante și imunosupresoare.',
      options: [{ handle: 'ashwagandha-moleqlar', label: '60 capsule', days: 60, fallbackPrice: 279 }]
    },
    collagen: {
      name: 'Colagen Peptide', role: 'Produs principal · peptide de colagen', days: 30, fallbackPrice: 259,
      reason: 'Materia primă centrală a direcției pentru piele și articulații, într-un singur produs ușor de înțeles.',
      options: [{ handle: 'colagen-peptide', label: 'Pulbere 450 g', days: 30, fallbackPrice: 259 }]
    },
    hyaluronic: {
      name: 'Acid Hialuronic', role: 'Completare · hidratare', days: 60, fallbackPrice: 189,
      reason: 'O completare pentru utilizatorii care pun accent pe hidratarea pielii și confortul articular.',
      options: [{ handle: 'hyaluron-acid-hialuronic', label: 'Capsule · 60 bucăți', days: 60, fallbackPrice: 189 }]
    },
    vitaminC: {
      name: 'Vitamina C Lipozomală', role: 'Produs principal · vitamina C', days: 60, fallbackPrice: 179,
      reason: 'O opțiune ușor de înțeles pentru aportul de vitamina C și o completare utilă în direcția colagenului.',
      options: [{ handle: 'vitamina-c-liposomala', label: '500 mg · 60 capsule', days: 60, fallbackPrice: 179 }]
    },
    zinc: {
      name: 'Zinc Complex', role: 'Completare · zinc', days: 60, fallbackPrice: 129,
      reason: 'O completare pentru aportul de zinc, nu un tratament pentru răceli sau infecții.',
      warning: 'Poate interfera cu unele antibiotice și cu penicilamina; administrarea trebuie separată conform sfatului medical.',
      options: [{ handle: 'zinc', label: '20 mg · 60 capsule', days: 60, fallbackPrice: 129 }]
    },
    d3k2: {
      name: 'Vitamina D3 + K2', role: 'Completare · D3 și K2', days: 60, fallbackPrice: 129, ageBoost: true,
      reason: 'O opțiune care merită aleasă în funcție de analize, doză și recomandarea medicului, nu automat.',
      warning: 'Vitamina K poate interacționa serios cu warfarina și anticoagulante similare; vitamina D poate interacționa cu unele diuretice și alte medicamente.',
      options: [{ handle: 'vitamina-d3-k2-capsule', label: '5000 UI + 200 mcg · 60 capsule', days: 60, fallbackPrice: 129 }]
    },
    creatine: {
      name: 'Creatină Creavitalis®', role: 'Produs principal · creatină', days: 60, fallbackPrice: 209,
      reason: 'Un produs simplu și bine cunoscut pentru efort și forță, folosit aici ca punct de pornire, nu ca înlocuitor al antrenamentului.',
      warning: 'Dacă ai boală renală cunoscută sau urmezi tratament care afectează rinichii, cere sfat medical înainte de utilizare.',
      options: [{ handle: 'creatina-monohidrata-300gr', label: 'Pulbere 300 g', days: 60, fallbackPrice: 209 }]
    },
    eaa: {
      name: 'Aminoacizi Esențiali EAA', role: 'Completare · aminoacizi', days: 40, fallbackPrice: 249, ageBoost: true,
      reason: 'O completare pentru situațiile în care aportul alimentar de proteine este greu de acoperit.',
      warning: 'În afecțiuni renale sau metabolice, aportul de aminoacizi trebuie discutat cu medicul.',
      options: [{ handle: 'amino-acizi-esentiali', label: 'Pulbere 500 g', days: 40, fallbackPrice: 249 }]
    },
    protein: {
      name: 'Enhanced Protein', role: 'Completare · proteină', days: 40, fallbackPrice: 384, ageBoost: true,
      reason: 'O completare practică atunci când alimentația nu acoperă constant aportul proteic.',
      warning: 'Dacă ai boală renală sau restricție proteică prescrisă, discută produsul cu medicul.',
      options: [{ handle: 'enhanced-protein-pulbere', label: 'Pulbere 1 kg', days: 40, fallbackPrice: 384 }]
    }
  };

  const QUIZ = [
    {
      title: 'Care este problema pe care vrei s-o rezolvi prima?',
      hint: 'Alege ce îți afectează cel mai mult rutina din ultima lună.',
      options: [
        ['energy-low', 'Rămân fără energie peste zi', 'Epuizare sau scădere de ritm după-amiaza.', { energy: 5, cell: 1 }],
        ['brain-fog', 'Îmi este greu să mă concentrez', 'Ceață mentală, memorie sau atenție.', { brain: 5, stress: 1 }],
        ['sleep-poor', 'Nu mă odihnesc bine', 'Adorm greu, mă trezesc sau rămân tensionat.', { stress: 5, energy: 1 }],
        ['healthy-age', 'Vreau o strategie de îmbătrânire sănătoasă', 'Caut un punct de pornire pe termen lung.', { cell: 5, heart: 1 }],
        ['markers', 'Mă preocupă markerii metabolici', 'Trigliceride, glicemie, tensiune sau circulație.', { heart: 5, cell: 1 }],
        ['skin-joints', 'Vreau sprijin pentru piele sau articulații', 'Elasticitate, hidratare și mobilitate.', { skin: 5, muscle: 1 }],
        ['immune', 'Vreau să-mi susțin aportul pentru imunitate', 'Mai ales în sezonul rece sau în perioade solicitante.', { immune: 5 }],
        ['strength', 'Vreau mai multă forță și recuperare', 'Antrenamente, masă musculară sau vitalitate.', { muscle: 5, energy: 1 }]
      ]
    },
    {
      title: 'Ce rezultat ai observa cel mai repede?',
      hint: 'Alege schimbarea care ar conta cel mai mult pentru tine.',
      options: [
        ['steady-day', 'O zi mai stabilă, fără căderi de ritm', 'Energie și claritate pentru activitățile zilnice.', { energy: 3, brain: 2 }],
        ['calm-night', 'Seri mai liniștite și somn mai ordonat', 'Mai puțină agitație la finalul zilei.', { stress: 4, brain: 1 }],
        ['better-numbers', 'Valori mai bine urmărite în analize', 'Vreau să discut deciziile și cu medicul.', { heart: 4, cell: 2 }],
        ['look-move', 'Piele mai bine îngrijită și mișcare confortabilă', 'Mă interesează structura și hidratarea.', { skin: 4, muscle: 1 }],
        ['recover', 'Recuperare mai bună după efort', 'Vreau să mențin forța și masa musculară.', { muscle: 4, energy: 2 }],
        ['resilience', 'O rutină mai bună pentru perioade solicitante', 'Mă interesează aportul de micronutrienți.', { immune: 4, stress: 1 }]
      ]
    },
    {
      title: 'Ce descrie mai bine contextul tău?',
      hint: 'Răspunsul doar ajustează ordinea; nu stabilește un diagnostic.',
      options: [
        ['over45', 'Am peste 45 de ani', 'Prioritizăm menținerea funcției și opțiunile potrivite contextului.', { cell: 2, heart: 2, muscle: 2 }],
        ['desk', 'Am multă muncă mentală și stres', 'Multe ore de concentrare, puține pauze.', { brain: 2, stress: 2 }],
        ['active', 'Mă antrenez sau fac efort fizic regulat', 'Recuperarea și energia contează în aceeași săptămână.', { muscle: 3, energy: 2 }],
        ['season', 'Sunt într-o perioadă în care răcesc des', 'Vreau să verific întâi obiceiurile și aportul de micronutrienți.', { immune: 3, stress: 1 }],
        ['general', 'Nu se potrivește exact niciuna', 'Păstrăm răspunsurile anterioare ca reper.', {}]
      ]
    }
  ];

  const byDirection = (id) => DIRECTIONS.find((direction) => direction.id === id);
  const money = (value) => `${Math.round(Number(value) || 0).toLocaleString('ro-RO')} lei`;
  const dayMoney = (value) => `${(Math.round((Number(value) || 0) * 10) / 10).toLocaleString('ro-RO')} lei/zi`;
  const escapeHtml = (value) => String(value || '').replace(/[&<>"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character]));

  ROOTS.forEach((root) => {
    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => [...root.querySelectorAll(selector)];
    const storageScope = root.dataset.lapStorageScope === 'live' ? 'live' : 'pilot';
    const storageKey = storageScope === 'live' ? 'longevity-architect:v1' : 'longevity-architect-poc:v1';
    const privateKey = storageScope === 'live' ? 'longevity-architect:private:v1' : 'longevity-architect-poc:private:v1';
    const visitorKey = 'nmn-analytics:visitor-id:v1';
    const sessionKey = 'nmn-analytics:architect-session-id:v1';
    const state = { directions: [], saved: [], formats: {}, age: false, meds: false, view: 'build' };
    let quizStep = 0;
    let quizAnswers = [];
    let quizResult = [];
    let lastFocus = null;
    let catalogPromise = null;
    let lastRecommendationFingerprint = '';

    function uuid() {
      if (window.crypto?.randomUUID) return window.crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
        const value = Math.random() * 16 | 0;
        return (character === 'x' ? value : (value & 3 | 8)).toString(16);
      });
    }

    function storedId(storage, key) {
      try {
        const existing = storage.getItem(key);
        if (existing) return existing;
        const created = uuid();
        storage.setItem(key, created);
        return created;
      } catch (error) { return uuid(); }
    }

    const visitorId = storedId(localStorage, visitorKey);
    const analyticsSessionId = storedId(sessionStorage, sessionKey);
    let customerContext = { logged_in: false };
    try { customerContext = JSON.parse($('[data-lap-customer-context]')?.textContent || '{"logged_in":false}'); } catch (error) { customerContext = { logged_in: false }; }

    function deviceType() {
      if (/ipad|tablet|playbook|silk/i.test(navigator.userAgent)) return 'tablet';
      if (/mobile|iphone|ipod|android/i.test(navigator.userAgent)) return 'mobile';
      return 'desktop';
    }

    const landingUrl = new URL(window.location.href);
    let referrerHost = '';
    try { referrerHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (error) { referrerHost = ''; }
    const analyticsSession = {
      landing_path: `${landingUrl.pathname}${landingUrl.search}`.slice(0, 300),
      referrer_host: referrerHost,
      utm_source: landingUrl.searchParams.get('utm_source'),
      utm_medium: landingUrl.searchParams.get('utm_medium'),
      utm_campaign: landingUrl.searchParams.get('utm_campaign'),
      utm_content: landingUrl.searchParams.get('utm_content'),
      utm_term: landingUrl.searchParams.get('utm_term'),
      device_type: deviceType(),
      locale: document.documentElement.lang || navigator.language,
      country_code: window.Shopify?.country || null,
      currency_code: window.Shopify?.currency?.active || null
    };

    function productPayload(productId) {
      const product = PRODUCTS[productId];
      const option = selectedOption(productId);
      if (!product || !option) return null;
      return {
        id: productId,
        name: product.name,
        handle: option.handle,
        variant_id: option.variantId || null,
        format: option.label,
        price: optionPrice(productId)
      };
    }

    function recommendationSet() {
      return [...state.directions, ...recommendations().map((entry) => entry.id)].join('|').slice(0, 120);
    }

    function sendToSupabase(event, detail) {
      const endpoint = root.dataset.lapEventsEndpoint;
      if (!endpoint) return;
      const product = detail.product ? productPayload(detail.product) : null;
      const payload = {
        event_id: uuid(),
        occurred_at: new Date().toISOString(),
        session_id: analyticsSessionId,
        visitor_id: visitorId,
        event_name: event,
        source_page: storageScope === 'live' ? 'architect_live' : 'architect_poc',
        page_path: window.location.pathname,
        page_title: document.title,
        session: analyticsSession,
        customer: customerContext,
        directions: Array.isArray(detail.directions) ? detail.directions : [...state.directions],
        quiz_answers: detail.quiz_answers || [],
        recommended_products: detail.recommended_products || [],
        selected_products: detail.selected_products || (Array.isArray(detail.products) ? detail.products.map(productPayload).filter(Boolean) : []),
        product_id: product?.id || null,
        product_handle: product?.handle || null,
        variant_id: product?.variant_id || null,
        product_format: detail.format || product?.format || null,
        recommendation_set: recommendationSet(),
        event_value: detail.value || null,
        currency_code: analyticsSession.currency_code,
        event_data: {
          age_45_plus: detail.age45,
          location: detail.location,
          count: detail.count,
          selection_method: detail.selection_method
        }
      };
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(() => { /* Analytics must never interrupt the customer journey. */ });
    }

    function track(event, detail) {
      const payload = { event, ...detail };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent(`nmn:${event}`, { detail }));
      sendToSupabase(event, detail || {});
    }

    function say(message) {
      const region = root.querySelector('.lap__sr');
      if (region) region.textContent = message;
    }

    function selectedOption(productId) {
      const product = PRODUCTS[productId];
      if (!product) return null;
      const index = Math.min(Number(state.formats[productId]) || 0, product.options.length - 1);
      state.formats[productId] = index;
      return product.options[index];
    }

    function optionPrice(productId) {
      const product = PRODUCTS[productId];
      const option = selectedOption(productId);
      return Number(option?.price ?? option?.fallbackPrice ?? product?.fallbackPrice ?? 0);
    }

    function optionDays(productId) {
      const product = PRODUCTS[productId];
      const option = selectedOption(productId);
      return Number(option?.days ?? product?.days ?? 0);
    }

    function optionDaily(productId) {
      const days = optionDays(productId);
      return days ? optionPrice(productId) / days : 0;
    }

    function safeStateFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const directions = (params.get('d') || '').split(',').filter((id) => byDirection(id)).slice(0, 2);
      const saved = (params.get('p') || '').split(',').filter((id) => PRODUCTS[id]);
      const formats = {};
      (params.get('f') || '').split(',').forEach((pair) => {
        const [id, rawIndex] = pair.split(':');
        const index = Number(rawIndex);
        if (PRODUCTS[id] && Number.isInteger(index) && index >= 0 && index < PRODUCTS[id].options.length) formats[id] = index;
      });
      return { directions, saved, formats, view: params.get('v') === 'review' && saved.length ? 'review' : 'build' };
    }

    function restore() {
      let stored = {};
      let privateState = {};
      try { stored = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (error) { stored = {}; }
      try { privateState = JSON.parse(sessionStorage.getItem(privateKey) || '{}'); } catch (error) { privateState = {}; }
      const urlState = safeStateFromUrl();
      const hasUrlState = new URLSearchParams(window.location.search).has('d') || new URLSearchParams(window.location.search).has('p');
      const source = hasUrlState ? urlState : stored;
      state.directions = Array.isArray(source.directions) ? source.directions.filter((id) => byDirection(id)).slice(0, 2) : [];
      state.saved = Array.isArray(source.saved) ? [...new Set(source.saved.filter((id) => PRODUCTS[id]))] : [];
      state.formats = source.formats && typeof source.formats === 'object' ? source.formats : {};
      state.view = hasUrlState ? urlState.view : (source.view === 'review' && state.saved.length ? 'review' : 'build');
      state.age = Boolean(privateState.age);
      state.meds = Boolean(privateState.meds);
    }

    function persist(mode = 'replace') {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ directions: state.directions, saved: state.saved, formats: state.formats, view: state.view }));
        sessionStorage.setItem(privateKey, JSON.stringify({ age: state.age, meds: state.meds }));
      } catch (error) { /* Storage can be unavailable in privacy mode. */ }
      const url = new URL(window.location.href);
      state.directions.length ? url.searchParams.set('d', state.directions.join(',')) : url.searchParams.delete('d');
      state.saved.length ? url.searchParams.set('p', state.saved.join(',')) : url.searchParams.delete('p');
      const formats = Object.entries(state.formats).filter(([id, index]) => PRODUCTS[id] && Number(index) > 0).map(([id, index]) => `${id}:${index}`);
      formats.length ? url.searchParams.set('f', formats.join(',')) : url.searchParams.delete('f');
      state.view === 'review' ? url.searchParams.set('v', 'review') : url.searchParams.delete('v');
      history[mode === 'push' ? 'pushState' : 'replaceState']({ lap: true }, '', url);
    }

    function productCatalogHandles() {
      return new Set(Object.values(PRODUCTS).flatMap((product) => product.options.map((option) => option.handle)));
    }

    function syncCatalog() {
      if (catalogPromise) return catalogPromise;
      catalogPromise = fetch('/products.json?limit=250', { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : Promise.reject(new Error('Catalog indisponibil')))
        .then((payload) => {
          const handles = productCatalogHandles();
          const catalog = new Map((payload.products || []).filter((product) => handles.has(product.handle)).map((product) => [product.handle, product]));
          Object.values(PRODUCTS).forEach((product) => product.options.forEach((option) => {
            const catalogProduct = catalog.get(option.handle);
            if (!catalogProduct) return;
            const variants = catalogProduct.variants || [];
            const match = option.variant
              ? variants.find((variant) => String(variant.title || '').toLowerCase().includes(String(option.variant).toLowerCase()))
              : null;
            const variant = (match?.available ? match : null) || variants.find((item) => item.available) || match || variants[0];
            option.price = Number(variant?.price || option.fallbackPrice || product.fallbackPrice || 0);
            option.variantId = variant?.id;
            option.available = Boolean(variant?.available);
            option.image = catalogProduct.images?.[0]?.src || '';
            option.productTitle = catalogProduct.title;
            option.url = `/products/${catalogProduct.handle}`;
          }));
          render();
          return true;
        })
        .catch((error) => {
          console.info('Arhitect POC: catalogul live nu a putut fi sincronizat.', error);
          return false;
        });
      return catalogPromise;
    }

    function recommendations() {
      if (!state.directions.length) return [];
      const primaryDirection = byDirection(state.directions[0]);
      const entries = [{ id: primaryDirection.main, role: 'primary', score: 100, reason: 'Punctul de pornire pentru direcția principală.' }];
      const score = new Map();
      const occurrences = new Map();
      state.directions.forEach((directionId, directionIndex) => {
        const direction = byDirection(directionId);
        [direction.main, ...direction.complements].forEach((id, itemIndex) => {
          if (id === primaryDirection.main) return;
          const value = (itemIndex === 0 ? 4 : 2) + (directionIndex === 1 ? .25 : 0);
          score.set(id, (score.get(id) || 0) + value);
          occurrences.set(id, (occurrences.get(id) || 0) + 1);
        });
      });
      score.forEach((value, id) => {
        if ((occurrences.get(id) || 0) > 1) score.set(id, value + 4);
        if (state.age && PRODUCTS[id]?.ageBoost) score.set(id, score.get(id) + .8);
      });
      [...score.entries()].sort((a, b) => b[1] - a[1]).slice(0, 2).forEach(([id]) => {
        const shared = (occurrences.get(id) || 0) > 1;
        const isSecondMain = state.directions[1] && byDirection(state.directions[1]).main === id;
        entries.push({
          id,
          role: 'optional',
          reason: shared ? 'Leagă cele două direcții selectate.' : isSecondMain ? 'Acoperă direcția secundară.' : 'Completează produsul principal fără să fie obligatoriu.'
        });
      });
      return entries;
    }

    function reconcileProtocol() {
      const allowed = new Set(recommendations().map((entry) => entry.id));
      state.saved = state.saved.filter((id) => allowed.has(id));
      Object.keys(state.formats).forEach((id) => {
        if (!allowed.has(id)) delete state.formats[id];
      });
      if (!state.saved.length) state.view = 'build';
    }

    function renderGoals() {
      const container = $('[data-lap-goals]');
      container.innerHTML = DIRECTIONS.map((direction) => {
        const index = state.directions.indexOf(direction.id);
        const role = index === 0 ? 'Direcție principală' : index === 1 ? 'Direcție secundară' : '';
        return `<button type="button" class="lap__goal" style="--lap-color:${direction.color}" data-direction="${direction.id}" aria-pressed="${index >= 0}">
          <span class="lap__goal-top"><h3>${direction.name}</h3><span class="lap__goal-dot" aria-hidden="true"></span></span>
          <p>${direction.symptom}</p><span class="lap__goal-role">${role}</span>
        </button>`;
      }).join('');
      $('[data-lap-goal-count]').textContent = `${state.directions.length} din 2 selectate`;
      container.querySelectorAll('[data-direction]').forEach((button) => button.addEventListener('click', () => toggleDirection(button.dataset.direction)));
    }

    function toggleDirection(id) {
      const index = state.directions.indexOf(id);
      if (index >= 0) {
        state.directions.splice(index, 1);
      } else if (state.directions.length < 2) {
        state.directions.push(id);
      } else {
        say('Poți selecta maximum două direcții. Deselectează una înainte să continui.');
        $('[data-lap-goal-count]').textContent = 'Maximum 2 direcții';
        return;
      }
      state.view = 'build';
      reconcileProtocol();
      persist('push');
      track('architect_direction_changed', { directions: [...state.directions] });
      render();
      if (state.directions.length === 2) {
        setTimeout(() => $('.lap__recommend-head').scrollIntoView({ behavior: 'smooth', block: 'start' }), 40);
      }
    }

    function renderRail() {
      const chosen = $('[data-lap-chosen]');
      if (state.directions.length) {
        const selected = state.directions.map(byDirection);
        chosen.hidden = false;
        $('[data-lap-chosen-dot]').style.background = selected[0].color;
        $('[data-lap-chosen-name]').textContent = selected.map((direction) => direction.name).join(' + ');
      } else chosen.hidden = true;
      const currentStep = state.view === 'review' ? 4 : !state.directions.length ? 1 : !state.saved.length ? 2 : 3;
      $$('[data-lap-step]').forEach((step) => {
        const number = Number(step.dataset.lapStep);
        step.classList.toggle('is-current', number === currentStep);
        step.classList.toggle('is-done', number < currentStep);
        step.querySelector('span').textContent = number < currentStep ? '✓' : number;
      });
    }

    function renderBridge() {
      const primary = byDirection(state.directions[0]);
      const secondary = byDirection(state.directions[1]);
      if (!primary) return;
      const terms = [...new Set([...(primary.terms || []), ...(secondary?.terms || [])])];
      $('[data-lap-bridge]').innerHTML = `<div class="lap__bridge-copy">
        <p class="lap__kicker">De ce începem aici</p>
        <h2>${primary.name}${secondary ? `, cu ${secondary.name.toLowerCase()} ca direcție secundară` : ''}</h2>
        <p>${primary.summary}${secondary ? ` Am folosit a doua direcție pentru a ordona completările, nu pentru a dubla numărul de produse.` : ''}</p>
        <div class="lap__direction-chips">${terms.map((term) => `<span>${term}</span>`).join('')}</div>
      </div><div class="lap__chain"><span>Logica recomandării</span><ol>${primary.chain.map((item, index) => `<li><span>${index + 1}</span><b>${item}</b></li>`).join('')}</ol></div>`;
    }

    function renderProduct(entry, index) {
      const product = PRODUCTS[entry.id];
      const option = selectedOption(entry.id);
      const daily = optionDaily(entry.id);
      const isSaved = state.saved.includes(entry.id);
      const isPrimary = index === 0;
      const warning = state.meds && product.warning ? `<div class="lap__product-warning"><b aria-hidden="true">!</b><span>${product.warning}</span></div>` : '';
      const formats = product.options.length > 1 ? `<span class="lap__format-label">Alege formatul</span><div class="lap__formats">${product.options.map((item, optionIndex) => `<button type="button" class="lap__format" data-format="${entry.id}:${optionIndex}" aria-pressed="${Number(state.formats[entry.id] || 0) === optionIndex}">${item.label}</button>`).join('')}</div>` : '';
      const image = option?.image ? `<img src="${escapeHtml(option.image)}" alt="${escapeHtml(product.name)}" loading="lazy" width="220" height="220">` : '<span class="lap__product-fallback" aria-hidden="true"></span>';
      return `<article class="lap__product ${isPrimary ? 'is-primary' : ''} ${isSaved ? 'is-saved' : ''}" data-product="${entry.id}">
        <div class="lap__product-image">${image}</div>
        <div class="lap__product-body">
          <div class="lap__product-top"><div><span class="lap__badge">${isPrimary ? 'Începe cu acesta' : 'Completare opțională'}</span><h3>${product.name}</h3></div>
          <div class="lap__price"><strong>${daily ? dayMoney(daily) : money(optionPrice(entry.id))}</strong><small>${money(optionPrice(entry.id))} produsul</small></div></div>
          <p class="lap__product-reason">${entry.reason} ${product.reason}</p>${formats}${warning}
          <div class="lap__product-actions"><a class="lap__product-link" href="${option?.url || `/products/${option.handle}`}">Vezi produsul</a>
          <button type="button" class="lap__add" data-toggle-product="${entry.id}" ${option?.available === false ? 'disabled' : ''}>${option?.available === false ? 'Indisponibil' : isSaved ? '✓ În protocol' : isPrimary ? 'Alege produsul principal' : 'Adaugă opțional'}</button></div>
        </div>
      </article>`;
    }

    function renderRecommendations() {
      const recs = recommendations();
      const primary = byDirection(state.directions[0]);
      const secondary = byDirection(state.directions[1]);
      $('[data-lap-result-title]').textContent = secondary ? `Un început pentru ${primary.name.toLowerCase()} + ${secondary.name.toLowerCase()}` : `Un început pentru ${primary.name.toLowerCase()}`;
      $('[data-lap-result-copy]').textContent = 'Produsul principal este separat clar de completări. Poți continua doar cu primul produs.';
      $('[data-lap-recommendations]').innerHTML = recs.map(renderProduct).join('');
      $$('[data-toggle-product]').forEach((button) => button.addEventListener('click', () => toggleProduct(button.dataset.toggleProduct)));
      $$('[data-format]').forEach((button) => button.addEventListener('click', () => {
        const [id, index] = button.dataset.format.split(':');
        state.formats[id] = Number(index);
        persist();
        track('architect_format_selected', { product: id, format: PRODUCTS[id].options[Number(index)].label });
        render();
      }));
      const fingerprint = `${state.directions.join(',')}|${recs.map((entry) => `${entry.id}:${state.formats[entry.id] || 0}`).join(',')}`;
      if (fingerprint !== lastRecommendationFingerprint) {
        lastRecommendationFingerprint = fingerprint;
        track('architect_recommendations_viewed', {
          directions: [...state.directions],
          recommended_products: recs.map((entry, index) => ({ ...productPayload(entry.id), role: index === 0 ? 'principal' : 'optional' })).filter(Boolean)
        });
      }
    }

    function toggleProduct(id) {
      const index = state.saved.indexOf(id);
      if (index >= 0) state.saved.splice(index, 1);
      else state.saved.push(id);
      persist();
      track(index >= 0 ? 'architect_product_removed' : 'architect_product_added', { product: id, count: state.saved.length });
      render();
      say(index >= 0 ? `${PRODUCTS[id].name} a fost scos din protocol.` : `${PRODUCTS[id].name} a fost adăugat în protocol.`);
    }

    function renderPanel() {
      const recs = recommendations();
      const count = state.saved.length;
      const totalDaily = state.saved.reduce((sum, id) => sum + optionDaily(id), 0);
      $('[data-lap-count]').textContent = count;
      $('[data-lap-panel-full]').hidden = !count;
      $('[data-lap-empty]').hidden = Boolean(count);
      if (!count) {
        const main = recs[0];
        $('[data-lap-empty]').innerHTML = main ? `<b>Începe simplu cu ${PRODUCTS[main.id].name}</b><span>${dayMoney(optionDaily(main.id))} · poți adăuga completările mai târziu</span><button type="button" data-add-main="${main.id}">Adaugă produsul principal</button>` : '<b>Alege o direcție ca să începem</b><span>Îți arătăm un produs principal și maximum două completări.</span>';
        $('[data-add-main]')?.addEventListener('click', (event) => toggleProduct(event.currentTarget.dataset.addMain));
      } else {
        $('[data-lap-protocol-list]').innerHTML = state.saved.map((id) => {
          const product = PRODUCTS[id];
          const option = selectedOption(id);
          return `<li><span><b>${product.name}</b><small>${option.label}</small></span><span class="lap__protocol-price">${dayMoney(optionDaily(id))}</span><button type="button" class="lap__remove" data-remove="${id}" aria-label="Scoate ${escapeHtml(product.name)}">×</button></li>`;
        }).join('');
        $$('[data-remove]').forEach((button) => button.addEventListener('click', () => toggleProduct(button.dataset.remove)));
        $('[data-lap-daily]').textContent = dayMoney(totalDaily);
        const warnings = state.saved.filter((id) => PRODUCTS[id].warning);
        const summary = $('[data-lap-warning-summary]');
        summary.hidden = !(state.meds && warnings.length);
        summary.textContent = state.meds && warnings.length ? `${warnings.length} ${warnings.length === 1 ? 'produs trebuie verificat' : 'produse trebuie verificate'} în contextul medicației tale.` : '';
      }
      $('[data-lap-goal-count]').textContent = `${state.directions.length} din 2 selectate`;
      $$('[data-lap-review]').forEach((button) => { button.disabled = !count; });
      const mobile = $('.lap__mobile-bar');
      mobile.hidden = state.view === 'review' || !state.directions.length;
      const mobileCount = $('[data-lap-mobile-count]');
      const mobileDaily = $('[data-lap-mobile-daily]');
      if (mobileCount) mobileCount.textContent = `${count} ${count === 1 ? 'produs' : 'produse'}`;
      if (mobileDaily) mobileDaily.textContent = dayMoney(totalDaily);
    }

    function renderReview() {
      const total = state.saved.reduce((sum, id) => sum + optionPrice(id), 0);
      const daily = state.saved.reduce((sum, id) => sum + optionDaily(id), 0);
      $('[data-lap-review-list]').innerHTML = state.saved.map((id) => {
        const product = PRODUCTS[id];
        const option = selectedOption(id);
        const image = option.image ? `<img src="${escapeHtml(option.image)}" alt="">` : '<span></span>';
        const productUrl = option.url || `/products/${option.handle}`;
        return `<li>${image}<span><b>${product.name}</b><small>${option.label} · ${dayMoney(optionDaily(id))}</small><a class="lap__review-product-link" href="${escapeHtml(productUrl)}" target="_blank" rel="noopener">Vezi detalii <span aria-hidden="true">↗</span></a></span><strong>${money(optionPrice(id))}</strong></li>`;
      }).join('');
      $('[data-lap-review-total]').textContent = money(total);
      $('[data-lap-review-daily]').textContent = `${state.saved.length} ${state.saved.length === 1 ? 'produs' : 'produse'} · ${dayMoney(daily)}`;
      const warnings = state.saved.filter((id) => PRODUCTS[id].warning);
      const warningBox = $('[data-lap-review-warning]');
      warningBox.hidden = !(state.meds && warnings.length);
      $('[data-lap-review-warning-list]').innerHTML = warnings.map((id) => `<div><b>${PRODUCTS[id].name}</b><p>${PRODUCTS[id].warning}</p></div>`).join('');
    }

    function render() {
      renderGoals();
      renderRail();
      $('[data-lap-age]').checked = state.age;
      $('[data-lap-meds]').checked = state.meds;
      const hasDirections = Boolean(state.directions.length);
      $('[data-lap-result]').hidden = !hasDirections;
      $('[data-lap-builder]').hidden = state.view === 'review';
      $('[data-lap-review-view]').hidden = state.view !== 'review';
      if (hasDirections) {
        renderBridge();
        renderRecommendations();
      }
      renderPanel();
      if (state.view === 'review') renderReview();
    }

    function showReview() {
      if (!state.saved.length) {
        say('Alege cel puțin un produs înainte de confirmare.');
        return;
      }
      state.view = 'review';
      closePanel();
      persist('push');
      track('architect_review_viewed', { products: [...state.saved], directions: [...state.directions] });
      render();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function showBuilder() {
      state.view = 'build';
      persist('push');
      render();
      setTimeout(() => $('[data-lap-result]').scrollIntoView({ behavior: 'smooth', block: 'start' }), 40);
    }

    function changeDirections() {
      if (state.view === 'review') {
        state.view = 'build';
        persist('push');
        render();
      }
      setTimeout(() => $('[data-lap-top]').scrollIntoView({ behavior: 'smooth', block: 'start' }), 40);
    }

    function openPanel() {
      $('[data-lap-panel]').classList.add('is-open');
      $('[data-lap-scrim]').classList.add('is-open');
      document.body.style.overflow = 'hidden';
      $('[data-lap-close-panel]').focus();
    }

    function closePanel() {
      $('[data-lap-panel]').classList.remove('is-open');
      if (!$('[data-lap-quiz]').hidden) return;
      $('[data-lap-scrim]').classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function quizScores() {
      const scores = {};
      quizAnswers.forEach((answerId, index) => {
        const option = QUIZ[index].options.find((item) => item[0] === answerId);
        Object.entries(option?.[3] || {}).forEach(([id, value]) => { scores[id] = (scores[id] || 0) + value; });
      });
      return Object.entries(scores).sort((a, b) => b[1] - a[1]);
    }

    function drawQuiz() {
      const body = $('[data-lap-quiz] .lap__quiz-body');
      const back = $('[data-lap-quiz] [data-lap-quiz-back]');
      back.hidden = quizStep === 0;
      if (quizStep < QUIZ.length) {
        const question = QUIZ[quizStep];
        const headerPosition = root.querySelector('[data-lap-quiz] header span');
        if (headerPosition) headerPosition.textContent = `Întrebarea ${quizStep + 1} din ${QUIZ.length}`;
        body.innerHTML = `<h2>${question.title}</h2><p>${question.hint}</p><div class="lap__quiz-options">${question.options.map((option, index) => `<button type="button" class="lap__quiz-option" data-quiz-option="${option[0]}"><span>${String.fromCharCode(65 + index)}</span><span><b>${option[1]}</b><small>${option[2]}</small></span></button>`).join('')}</div>`;
        body.querySelectorAll('[data-quiz-option]').forEach((button) => button.addEventListener('click', () => {
          track('architect_quiz_answered', {
            quiz_answers: [{ question_id: `architect_q${quizStep + 1}`, answer_id: button.dataset.quizOption }]
          });
          quizAnswers[quizStep] = button.dataset.quizOption;
          quizStep += 1;
          drawQuiz();
        }));
        body.querySelector('button')?.focus();
        return;
      }
      const ranked = quizScores();
      const primary = ranked[0]?.[0] || 'energy';
      const second = ranked[1] && ranked[1][1] >= ranked[0][1] * .55 ? ranked[1][0] : null;
      quizResult = [primary, second].filter(Boolean).slice(0, 2);
      const selected = quizResult.map(byDirection);
      const headerPosition = root.querySelector('[data-lap-quiz] header span');
      if (headerPosition) headerPosition.textContent = 'Propunerea ta';
      body.innerHTML = `<h2>Cu această direcție merită să începi</h2><p>Este o orientare bazată pe prioritățile selectate, nu un diagnostic.</p>
        <div class="lap__quiz-result">${selected.map((direction, index) => `<div class="lap__quiz-result-row"><span class="lap__quiz-result-dot" style="background:${direction.color}"></span><b>${direction.name}</b><span>${index === 0 ? 'principală' : 'secundară'}</span></div>`).join('')}</div>
        <div class="lap__quiz-actions"><button type="button" class="is-primary" data-quiz-accept="all">Folosește ${selected.length === 2 ? 'ambele direcții' : 'direcția'}</button>${selected.length === 2 ? '<button type="button" class="is-secondary" data-quiz-accept="primary">Doar direcția principală</button>' : ''}<button type="button" class="is-secondary" data-quiz-manual>Aleg singur</button></div>`;
      body.querySelectorAll('[data-quiz-accept]').forEach((button) => button.addEventListener('click', () => {
        state.directions = button.dataset.quizAccept === 'primary' ? [quizResult[0]] : [...quizResult];
        if (quizAnswers.includes('over45')) state.age = true;
        state.view = 'build';
        reconcileProtocol();
        closeQuiz();
        persist('push');
        track('architect_quiz_completed', {
          directions: [...state.directions],
          quiz_answers: quizAnswers.map((answer, index) => ({ question_id: `architect_q${index + 1}`, answer_id: answer })),
          recommended_products: recommendations().map((entry, index) => ({ ...productPayload(entry.id), role: index === 0 ? 'principal' : 'optional' })).filter(Boolean),
          selection_method: 'guided_quiz'
        });
        render();
        setTimeout(() => $('[data-lap-result]').scrollIntoView({ behavior: 'smooth', block: 'start' }), 40);
      }));
      body.querySelector('[data-quiz-manual]')?.addEventListener('click', () => { closeQuiz(); $('[data-lap-top]').scrollIntoView({ behavior: 'smooth' }); });
      body.querySelector('button')?.focus();
    }

    function openQuiz() {
      lastFocus = document.activeElement;
      quizStep = 0;
      quizAnswers = [];
      quizResult = [];
      $('[data-lap-quiz]').hidden = false;
      $('[data-lap-scrim]').classList.add('is-open');
      document.body.style.overflow = 'hidden';
      drawQuiz();
      track('architect_quiz_started', {});
    }

    function closeQuiz() {
      $('[data-lap-quiz]').hidden = true;
      $('[data-lap-scrim]').classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus instanceof HTMLElement) lastFocus.focus();
    }

    async function addToCart() {
      const button = $('[data-lap-cart]');
      button.disabled = true;
      button.textContent = 'Adăugăm…';
      const ready = await syncCatalog();
      const items = state.saved.map((id) => ({ id, option: selectedOption(id) })).filter(({ option }) => option?.variantId && option.available).map(({ id, option }) => ({
        id: option.variantId,
        quantity: 1,
        properties: {
          _architect_source: 'longevity-architect',
          _architect_session_id: analyticsSessionId,
          _architect_visitor_id: visitorId,
          _architect_recommendation_set: recommendationSet(),
          _architect_product_id: id,
          _architect_product_handle: option.handle
        }
      }));
      if (!ready || !items.length) {
        button.disabled = false;
        button.textContent = 'Trimite la coș';
        say('Catalogul nu este disponibil momentan. Reîncearcă în câteva secunde.');
        return;
      }
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Cart error');
        track('architect_add_to_cart', {
          products: [...state.saved],
          count: items.length,
          value: state.saved.reduce((sum, id) => sum + optionPrice(id), 0)
        });
        window.location.assign('/cart');
      } catch (error) {
        button.disabled = false;
        button.textContent = 'Trimite la coș';
        say('Coșul nu a putut fi actualizat. Te rugăm să încerci din nou.');
      }
    }

    async function submitEmail(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const email = $('[data-lap-email]');
      const consent = $('[data-lap-consent]');
      const message = $('[data-lap-email-message]');
      const button = $('[data-lap-email-submit]');
      if (!email.value.trim() || !email.validity.valid) {
        message.textContent = 'Introdu o adresă de email validă.';
        email.focus();
        return;
      }
      if (!consent.checked) {
        message.textContent = 'Bifează acordul pentru a te înscrie.';
        consent.focus();
        return;
      }
      button.disabled = true;
      button.textContent = 'Înregistrăm…';
      message.textContent = '';
      try {
        const response = await fetch(form.action, { method: form.method || 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' } });
        if (!response.ok) throw new Error('Email submit error');
        message.classList.add('is-success');
        message.textContent = 'Emailul a fost înregistrat. Mulțumim!';
        button.textContent = 'Înscris ✓';
        customerContext = { ...customerContext, email: email.value.trim() };
        track('architect_email_captured', { location: 'review' });
      } catch (error) {
        button.disabled = false;
        button.textContent = 'Înscrie-mă';
        message.classList.remove('is-success');
        message.textContent = 'Nu am putut înregistra emailul. Te rugăm să încerci din nou.';
      }
    }

    $$('[data-lap-change]').forEach((button) => button.addEventListener('click', changeDirections));
    $('[data-lap-open-quiz]').addEventListener('click', openQuiz);
    $('[data-lap-quiz] [data-lap-quiz-back]').addEventListener('click', () => {
      if (quizStep > 0) {
        quizStep -= 1;
        quizAnswers = quizAnswers.slice(0, quizStep);
        drawQuiz();
      }
    });
    root.querySelector('[data-lap-quiz] button[aria-label="Închide"]').addEventListener('click', closeQuiz);
    $('[data-lap-scrim]').addEventListener('click', () => { closePanel(); if (!$('[data-lap-quiz]').hidden) closeQuiz(); });
    $('[data-lap-age]').addEventListener('change', (event) => { state.age = event.target.checked; persist(); render(); track('architect_profile_changed', { age45: state.age }); });
    $('[data-lap-meds]').addEventListener('change', (event) => { state.meds = event.target.checked; persist(); render(); });
    $$('[data-lap-review]').forEach((button) => button.addEventListener('click', showReview));
    $$('[data-lap-back]').forEach((button) => button.addEventListener('click', showBuilder));
    $('[data-lap-open-panel]').addEventListener('click', openPanel);
    $('[data-lap-close-panel]').addEventListener('click', closePanel);
    $('[data-lap-cart]').addEventListener('click', addToCart);
    $('.lap__email-form').addEventListener('submit', submitEmail);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (!$('[data-lap-quiz]').hidden) closeQuiz();
        else closePanel();
      }
      if (event.key === 'Tab' && !$('[data-lap-quiz]').hidden) {
        const focusable = $$('[data-lap-quiz] button:not([hidden]):not([disabled])');
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('popstate', () => {
      const urlState = safeStateFromUrl();
      state.directions = urlState.directions;
      state.saved = urlState.saved;
      state.formats = urlState.formats;
      state.view = urlState.view;
      reconcileProtocol();
      persist();
      render();
    });

    restore();
    reconcileProtocol();
    persist();
    render();
    syncCatalog();
    track('architect_viewed', {});
  });
})();
